import { createBrowserRouter } from 'react-router-dom';
import { lazy } from 'react';

// routes
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import Loadable from 'ui-component/Loadable';
// import ManagementRoutes from './ManagementRoutes';
// Add FAQ route import if needed

const SsoCallback = Loadable(lazy(() => import('views/pages/authentication/SsoCallback')));

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([
  { path: '/users/sso_callback', element: <SsoCallback /> },
  LoginRoutes,
  MainRoutes,
  // ManagementRoutes
], { basename: import.meta.env.VITE_APP_BASE_NAME });

export default router;